import type { Transaction } from "@rocicorp/zero";
import { userFacingError } from "../../authorization";
import type { Schema } from "../../generatedDrizzleSchema";
import {
  activeTenantAdminUserGrants,
  tenantAdminUserGrants,
} from "../tenantAdmins";

export const MIN_TENANT_ADMINS = 1;

export const LAST_ADMIN_ERROR = "Cannot remove the last tenant admin";

type Tx = Pick<Transaction<Schema>, "run">;

export async function assertNotLastAdmin(
  tx: Tx,
  tenantId: string,
  userId: string
): Promise<void> {
  const adminGrants = await tx.run(
    tenantAdminUserGrants(tenantId).where("userId", userId)
  );
  if (adminGrants.length === 0) return;

  const otherAdminGrants = await tx.run(
    activeTenantAdminUserGrants(tenantId, userId)
  );
  if (otherAdminGrants.length < MIN_TENANT_ADMINS) {
    throw userFacingError(LAST_ADMIN_ERROR);
  }
}
